"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SKAdAvailabilityReponseToJSON = exports.SKAdAvailabilityReponseFromJSONTyped = exports.SKAdAvailabilityReponseFromJSON = exports.instanceOfSKAdAvailabilityReponse = void 0;
var runtime_1 = require("../runtime");
/**
 * Check if a given object implements the SKAdAvailabilityReponse interface.
 */
function instanceOfSKAdAvailabilityReponse(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfSKAdAvailabilityReponse = instanceOfSKAdAvailabilityReponse;
function SKAdAvailabilityReponseFromJSON(json) {
    return SKAdAvailabilityReponseFromJSONTyped(json, false);
}
exports.SKAdAvailabilityReponseFromJSON = SKAdAvailabilityReponseFromJSON;
function SKAdAvailabilityReponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'adAccountId': !(0, runtime_1.exists)(json, 'ad_account_id') ? undefined : json['ad_account_id'],
        'mobileAppId': !(0, runtime_1.exists)(json, 'mobile_app_id') ? undefined : json['mobile_app_id'],
        'skadNetworkAvailable': !(0, runtime_1.exists)(json, 'skad_network_available') ? undefined : json['skad_network_available'],
    };
}
exports.SKAdAvailabilityReponseFromJSONTyped = SKAdAvailabilityReponseFromJSONTyped;
function SKAdAvailabilityReponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'ad_account_id': value.adAccountId,
        'mobile_app_id': value.mobileAppId,
        'skad_network_available': value.skadNetworkAvailable,
    };
}
exports.SKAdAvailabilityReponseToJSON = SKAdAvailabilityReponseToJSON;
